module.exports = __webpack_public_path__ + "static/img/info.0fb58a0e.png";